import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Aggregation } from '../../models/grid-data.model';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { DecimalPipe } from '@angular/common';
import { AggregationLabelPipe } from '../../pipes/aggregation-label.pipe';

@Component({
    selector: 'app-aggregation-dropdown',
    templateUrl: './aggregation-dropdown.component.html',
    styleUrls: ['./aggregation-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatFormField,
        MatSelect,
        MatOption,
        DecimalPipe,
        AggregationLabelPipe,
    ]
})
export class AggregationDropdownComponent {
  readonly aggregations = input<Aggregation[]>(undefined);

  compareAggregations = (a: Aggregation, b: Aggregation): boolean =>
    a?.columnId === b?.columnId && a?.type === b?.type;
}
